import axios from 'axios'

import { PRODUCTSIZE as ENDPOINT } from '../common/endpoints'

async function checkAvailability (
	{ id, code, size, brand, quantity },
	callback
) {
	if (!window.motostorm) {
		console.warn('missing global namespace variables')
	}

	try {
		const { lang, country } = window.motostorm

		const res = await axios.get(ENDPOINT, {
			params: {
				id,
				codice: code,
				lang,
				paese: country,
				size,
				marca: brand,
				quantity
			},
		})

		if (typeof callback === 'function') {
			callback(res)
		}
	} catch (error) {
		console.warn(error)
	}

	if (typeof callback === 'function') {
		callback(null)
	}

	return false
}

const { productId, productCode, productBrand } = window.motostorm.product
const availabilityInfoNode = document.getElementById('availability-info')
const sizeSelectNode = document.getElementById('sizes-select')
const qtySelectNode = document.getElementById('id-quantity')

if (sizeSelectNode) {
	sizeSelectNode.addEventListener('change', function () {
		availabilityInfoNode.innerHTML = '<img style="width:16px" src="/images/loading.gif" />'
		if (sizeSelectNode.value) {
			checkAvailability({
				id: productId,
				code: productCode,
				size: sizeSelectNode.value,
				brand: productBrand,
				quantity: qtySelectNode.value
			}, (res) => {
				if (res) {
					availabilityInfoNode.innerHTML = res.data
				}
			})
		}
	})
}
